import { isEmpty } from "lodash";

export function formatDate(dateString) {
    if (!dateString || isEmpty(dateString)) return "";
    // console.log("🚀 ~ formatDate ~ dateString:", dateString);
    const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", options).format(date).replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$3-$1-$2");
}

export function getCurrentDateTimeString() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    return `${year}_${month}_${day}_${hours}${minutes}${seconds}`;
}

export function getCurrentDateString() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export const numberRegex = new RegExp(/^\d+$/);

export function getAccountLockLevel({ login_permanently_locked, login_locked_until } = {}) {
    if (login_permanently_locked) return "permanent";
    if (login_locked_until && new Date(login_locked_until).getTime() > Date.now()) return "temporary";
    return "normal";
}

export function isAccountLocked(cond) {
    return getAccountLockLevel(cond) !== "normal";
}

export const ACCOUNT_LOCK_STATUS = {
    normal: { label: "정상", bg: "#ECF7F1", border: "#CBE7DA", ink: "#1B6B49", dot: "#1F8A5B" },
    temporary: { label: "임시 잠금", bg: "#FDF4E7", border: "#F0DDBC", ink: "#8A5A08", dot: "#B4720A" },
    permanent: { label: "영구 잠금", bg: "#FCEFEE", border: "#F0D2CF", ink: "#8E2B23", dot: "#B4322A" },
};
